import styled from 'styled-components';

export const MenuButtonContainer = styled.div`
	display: flex;
	flex: 1;
`;
